export default __webpack_public_path__ + "static/media/wait-dark.6c718526.svg";